/**
 * modalShared — style helpers used by every tools-panel modal.
 *
 * Centralised so all modals share identical chrome — when the dark
 * theme palette changes, this is the only file you touch.
 *
 * The accompanying `ModalHeader.tsx` exports the matching header
 * component (kept in a separate file because this module is .ts).
 */
import type { CSSProperties } from 'react'

/** Full-screen translucent overlay that centres a modal in the viewport. */
export const modalOverlay: CSSProperties = {
  position: 'fixed',
  inset: 0,
  background: 'rgba(0,0,0,0.55)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 99999,
}

/** Inner box at a specified width — dark navy theme matching FOM modals. */
export function modalBox(width = 600): CSSProperties {
  return {
    background: 'var(--bg-elevated)',
    border: '1px solid var(--border)',
    borderRadius: 16,
    padding: 24,
    width,
    maxHeight: '85vh',
    overflowY: 'auto',
    color: 'var(--text-primary)',
    boxShadow: '0 20px 60px rgba(0,0,0,0.6)',
  }
}

/** Single-line dark input style used inside modals. */
export const darkInput: CSSProperties = {
  background: 'var(--bg-deep)',
  border: '1px solid var(--border)',
  borderRadius: 8,
  padding: '6px 10px',
  color: 'var(--text-primary)',
  fontSize: 13,
  outline: 'none',
}

/** Row container for list entries inside modals (audit log, users, etc). */
export const entryRow: CSSProperties = {
  background: 'var(--bg-deep)',
  border: '1px solid var(--border)',
  borderRadius: 8,
  padding: '10px 14px',
  marginBottom: 8,
}
